import type { Site } from "@/api/siteDetails";

export function getLockedSenderDomain(
  site: Pick<Site, "default_from_email"> | undefined,
): string {
  const fromEmail = site?.default_from_email?.trim();
  if (!fromEmail) {
    return "";
  }
  const at = fromEmail.lastIndexOf("@");
  return at === -1 ? "" : fromEmail.slice(at + 1).trim();
}

export function localPartFromEmail(email: string): string {
  const at = email.lastIndexOf("@");
  return at === -1 ? email.trim() : email.slice(0, at).trim();
}

export function combineLocalWithDomain(local: string, domain: string): string {
  return `${local.trim()}@${domain}`;
}

/** Strips any domain suffix the user pasted so the locked domain always wins. */
export function normalizeLocalInput(raw: string): string {
  const v = raw;
  const at = v.indexOf("@");
  return at === -1 ? v.trim() : v.slice(0, at).trim();
}
